import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Button, Select } from 'antd';
import {
  updateAgentAction,
  getAgentAction,
  listAgentsAction,
} from '../../../../store/actions/agents.action';
import { showToastError } from 'src/utilities/errortoast';

const product_options = [
  { value: 'phone-triage', label: 'Phone Triage' },
  { value: 'fax', label: 'Fax' },
];

const EditAgent = ({
  isOpen,
  setIsOpen,
  agentId,
  isfilterOn,
  filterValue,
  orgUuid,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { agentsItem, agentsLoading } = useSelector(
    (state) => state?.agentsState
  );

  useEffect(() => {
    if (isOpen && agentId && orgUuid) {
      dispatch(getAgentAction(orgUuid, agentId));
    }
  }, [dispatch, isOpen, agentId, orgUuid]);

  useEffect(() => {
    if (agentsItem?.agent && isOpen) {
      form.setFieldsValue({
        name: agentsItem?.agent?.name,
        external_id: agentsItem?.agent?.external_id,
        product: agentsItem?.agent?.product,
      });
    }
  }, [agentsItem, isOpen, form]);

  const handleClose = () => {
    form.resetFields();
    setIsOpen(false);
  };

  const handleSubmit = async () => {
    if (!orgUuid) {
      showToastError('Organization UUID is required');
      return;
    }

    const values = await form.validateFields();
    const { name, external_id, product } = values;
    const payload = {
      name: name.trim(),
      external_id: external_id.trim(),
      product: product,
    };

    try {
      await dispatch(
        updateAgentAction(orgUuid, agentId, payload, () => {
          handleClose();
          dispatch(listAgentsAction(orgUuid, filterValue));
        })
      );
    } catch (error) {
      showToastError('Failed to update agent');
    }
  };

  return (
    <Modal
      loading={agentsLoading}
      title="Edit Agent"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label="Agent Name"
          rules={[
            { required: true, message: 'Please enter agent name' },
            { min: 2, message: 'Agent name must be at least 2 characters' },
            { max: 100, message: 'Agent name must not exceed 100 characters' },
          ]}
        >
          <Input placeholder="Enter agent name" maxLength={100} />
        </Form.Item>

        <Form.Item
          name="external_id"
          label="External ID"
          rules={[
            { max: 500, message: 'External ID must not exceed 500 characters' },
          ]}
        >
          <Input placeholder="Enter external ID (optional)" maxLength={500} />
        </Form.Item>

        <Form.Item name="product" label="Product">
          <Select placeholder="Select product" options={product_options} />
        </Form.Item>

        <div className="flex justify-end">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" disabled={!orgUuid}>
            Save Changes
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditAgent;
